/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { Button, Stack, Typography } from '@mui/material';
import qs from 'qs';
import { styled } from '@mui/material/styles';
import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { KeyboardArrowUpOutlined } from '@mui/icons-material';
import { get, isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  getTotalDiscountAmount,
  getTotalTripPrice,
} from '@/utils/tripMapping';
import { convertMoney } from '@/utils/convertMoney';
import { useAppSelector } from '../../utils/hook';
import { BookingFlightStatusEnum } from '@/slices/myBooking/slices/type';
import { BottomContainer } from '../../components/BottomContainer';
import { pr } from '@/utils/pxToRem';
// import { setTotalFare } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { setDepartFare } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { resetGlobalAll, setOrderId } from '@/slices/global/globalSlice';

const SmallButton = styled(Button)({
  minWidth: 0,
  display: 'flex',
  justifyContent: 'start',
  padding: 0,
});
const StyledTypography = styled(Typography)({
  marginRight: pr`8px`,
});

interface TripDetailPriceProps {
  onBtnClick?: () => void;
  isPayment?: boolean;
  isDisabled?: boolean;
}

const TripDetailPrice: React.FC<TripDetailPriceProps> = ({
  onBtnClick,
  isPayment,
  isDisabled,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const query = isEmpty(router.query)
    ? qs.parse(router.asPath.split('?')[1]) || {}
    : router.query;
  const [isLoading, setLoading] = useState(!!isPayment);

  const {
    // totalFare: cachedTotalFare,
    flight: selectedFlight,
    returnFlight: selectedReturnFlight,
    flightPriceDiff,
    returnFlightPriceDiff,
  } = useAppSelector((state) => state.selectedFlight);
  // const reserveOrderError = useAppSelector((state) => state.global.reserveOrderError);
  const globalSlice = useAppSelector(
    (state) => state.global,
  );
  const { reserveResponse } = globalSlice;
  let { orderId } = globalSlice;
  const passenger = useAppSelector((state) => state.searchFlightForm.passenger);
  const myBookingFlight = useAppSelector((state) => state.myBooking.flights);
  const selectedBaggages = useAppSelector(
    (state) => state.baggage.selectedBaggages,
  );

  const [openPriceDetailsDrawer, setOpenPriceDetailsDrawer] = useState(false);
  const totalPassenger = Object.values(passenger).reduce(
    (curValue: number, nextValue: number) => curValue + nextValue,
  );

  const selectedFlightCache = useMemo(
    () => myBookingFlight.find(
      (flight) => (flight.bookingCode === query?.code) || (flight.id === Number(query?.id || 0)),
    ),
    [myBookingFlight],
  );

  if (isLoading) {
    if (reserveResponse) {
      const order = get(reserveResponse, 'orders[0]');
      if (order && order.id && (order.id !== orderId)) {
        orderId = order.id;
        dispatch(setOrderId({ orderId }));
        router.replace('/pay', {
          query: {
            phone: order.contactPhone,
            email: order.contactEmail,
            value: order.amount,
            code: order.code,
            id: orderId,
          },
        }, { shallow: true });
      }
      setLoading(false);
    } else if (orderId) {
      setLoading(false);
    }
  }

  if (isPayment && !isPayment) {
    setTimeout(
      () => router.push('/route-flight', {}, { shallow: true }),
      60 * 1000,
    );
  }

  useEffect(() => {
    if (selectedFlightCache) {
      setLoading(false);
    }
  }, []);

  const shouldBtnDisable = useMemo(() => {
    if (isDisabled) return true;
    if (isPayment) {
      if (
        !orderId
        && !selectedFlightCache?.bookingCode
        && selectedFlightCache?.bookingInfo?.status
        !== BookingFlightStatusEnum.PENDING
      ) {
        return true;
      }
    }
    return false;
  }, [selectedFlightCache, orderId, isDisabled, isPayment]);

  const listAirline: any = useMemo(() => {
    const arr = [];
    arr.push(selectedFlight?.company.name);
    if (selectedReturnFlight && arr[0] !== selectedReturnFlight?.company.name) { arr.push(selectedReturnFlight?.company.name); }
    return arr;
  }, []);

  if (typeof window !== 'undefined' && !selectedFlight) {
    // TODO: GYL-712
    // router.push('/');
  }

  if (!selectedFlight) {
    return <></>;
  }

  let departBaggagePrice = 0;
  let returnBaggagePrice = 0;
  if (isPayment) {
    departBaggagePrice = (selectedBaggages.depart || []).reduce(
      (total, baggageData) => total + baggageData.baggage.price,
      0,
    );
    returnBaggagePrice = (selectedBaggages.return || []).reduce(
      (total, baggageData) => total + baggageData.baggage.price,
      0,
    );
  }

  const discountAmount = get(selectedFlight, 'route.schedules[0].discountAmount') || 0;
  const returnDiscountAmount = get(selectedReturnFlight, 'route.schedules[0].discountAmount') || 0;
  const totalBaggagePrice = departBaggagePrice + returnBaggagePrice;
  const totalPrice = getTotalTripPrice(selectedFlight, passenger) + departBaggagePrice;
  const totalReturnPrice = ((selectedReturnFlight
    && getTotalTripPrice(selectedReturnFlight, passenger))
    || 0) + returnBaggagePrice;
  const totalDiscountAmount = getTotalDiscountAmount(
    discountAmount + returnDiscountAmount,
    passenger,
  );

  const totalFare = (totalPrice + totalReturnPrice) - totalDiscountAmount;
  // if (totalFare && cachedTotalFare !== totalFare) {
  //   dispatch(setTotalFare(totalFare));
  // }
  // if (totalFare) { dispatch(setTotalFare(totalFare)); }
  const isDepart = router.query?.type === 'depart';
  if (totalPrice && isDepart) { dispatch(setDepartFare(totalPrice - discountAmount)); }

  const handleNextPage = () => {
    if (!router.asPath.includes('add-baggage')) {
      dispatch(resetGlobalAll());
    }
    dispatch(setOrderId({ orderId: '' }));
    onBtnClick?.();
  };

  return (
    <BottomContainer
      isDisabled={isDisabled}
      listAirline={listAirline || []}
      priceDetailsObj={{
        flightPriceDiff: flightPriceDiff + returnFlightPriceDiff,
        flightArr: [selectedFlight].concat(selectedReturnFlight ? [selectedReturnFlight] : []),
        passenger,
        totalBaggagePrice,
        departBaggagePrice,
        returnBaggagePrice,
        totalDiscountAmount,
      }}
      isLoadingDisabled={shouldBtnDisable}
      isPayment={isPayment}
      isLoading={isLoading}
      handleNextPage={handleNextPage}
      setOpenPriceDetailsDrawer={setOpenPriceDetailsDrawer}
      openPriceDetailsDrawer={openPriceDetailsDrawer}
      isDepart={isDepart}
    >
      <Stack spacing={0}>
        <SmallButton onClick={() => setOpenPriceDetailsDrawer(true)}>
          <StyledTypography variant="contentRegular">
            Tổng cộng
          </StyledTypography>
          <KeyboardArrowUpOutlined />
        </SmallButton>

        <Typography variant="title">
          {`${convertMoney(
            totalFare,
          )}/ ${totalPassenger} người`}
        </Typography>
      </Stack>
    </BottomContainer>
  );
};

export default TripDetailPrice;
